module.exports = __webpack_public_path__ + "img/vector-shape5.5e898e65.png";